import React from 'react';
import {observer} from 'mobx-react';
import {Box} from '@mui/material';
import FormSection from '../../../forms/FormSection';
import FormRow from '../../../forms/FormRow';
import FormColumn from '../../../forms/FormColumn';
import CompletionProgressBar from '../../../components/CompletionProgressBar';
import FormSkeleton from '../../../components/FormSkeleton';
import useFeature from '../../../useFeature';
import {useApplication} from "../../../ApplicationProvider";
import FormAutocompleteField from "../../../components/fields/FormAutocompleteField";

function CommercialTermsPanel({ generalFeature }) {
    const application = useApplication();
    const feature = useFeature(() => generalFeature.features['CommercialTermsFeature'])

    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    }

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton 
                title="Condiciones Comerciales"
                rows={3} 
                fieldsPerRow={3} 
            />
        );
    }

    const form = feature.form;
    return (
        <Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={form} />
            <FormSection title="Condiciones Comerciales">
                <FormColumn>
                    <FormRow>
                        <FormAutocompleteField
                            label="Lista de precios"
                            form={form}
                            fieldName={"priceList"}
                            options={feature.priceListsOptions()}
                        />
                        <FormAutocompleteField
                            label="Condicion de pago"
                            form={form}
                            options={feature.paymentTermsOptions()}
                            fieldName={"paymentTerm"}
                            allowFreeText={true}
                        />
                        <FormAutocompleteField
                            label="Agrupamiento de clientes"
                            form={form}
                            fieldName={"customerGroup"}
                            options={feature.customerGroupsOptions()}
                        />
                    </FormRow>
                    <FormRow>
                        <FormAutocompleteField
                            label="Medio de pago"
                            form={form}
                            fieldName={"paymentMethod"}
                            options={feature.paymentMethodOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
            <FormSection title="Categoría de Cliente">
                <FormColumn>
                    <FormRow>
                        <FormAutocompleteField
                            label="Tipo de Cliente"
                            form={form}
                            fieldName={"segment"}
                            options={feature.segmentsOptions()}
                            save={() => feature.paymentMethodOptions()}
                        />
                        <FormAutocompleteField
                            label="Subcategoría Horeca"
                            form={form}
                            fieldName={"horecaSubcategory"}
                            options={feature.horecaSubcategoriesOptions()}
                            save={() => feature.paymentMethodOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
        </Box>
    );
}

export default observer(CommercialTermsPanel);
